import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { useLocation, Link as RouterLink } from 'react-router-dom';

const PageFailure = () => {
	const { pathname } = useLocation();
	return (
		<Container align='center' sx={{ my: { xs: 3, md: 5 } }}>
			<Typography variant='h5'>
				We&apos;re sorry, something went wrong.
			</Typography>
			<Typography
				sx={{ my: { xs: 1, md: 2 } }}
				variant='body3'
				data-testid='page-failure-message'
			>
				We&apos;re unable to load the page at this time. Please refresh
				and try again.
			</Typography>
			<Button
				sx={{ mt: { xs: 1, md: 2 } }}
				variant='contained'
				component={RouterLink}
				to={pathname}
				target='_self'
			>
				Refresh
			</Button>
		</Container>
	);
};
export default PageFailure;
